export default "__VITE_ASSET__oVdeGsrV__"